// extracted by mini-css-extract-plugin
module.exports = {"chat":"roomStyles_chat__1OoYW","bingoRoom":"roomStyles_bingoRoom__NTKWp","members":"roomStyles_members__WYffS","bingoGame":"roomStyles_bingoGame__BiDdf"};